import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';

import {EMPTY, firstValueFrom, of} from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';

import { BaseFormComponent, FormManagerService } from '@sim/form';

import { CardsApiService, SwalService } from '@atmi/core';
import { cardOA } from '@atmi/core/models';
import { checkUniqueCodeDuplicate } from '@atmi/core/validators';

export interface CardDialogData {
  cardOa: cardOA.CardOA;
}

@Component({
  selector: 'app-card-dialog',
  styleUrls: ['./card-dialog.component.scss'],
  templateUrl: './card-dialog.component.html',
})
export class CardDialogComponent extends BaseFormComponent<cardOA.CardOA> {

  readonly title = this.translate.instant('Crea scheda figlia di ') + this.data.cardOa.SGT.SGTT;

  readonly mainActionLabel = this.translate.instant('Crea');

  constructor(
    private readonly dialogRef: MatDialogRef<CardDialogComponent>,
    private readonly swalService: SwalService,
    private readonly cardsApi: CardsApiService,
    protected readonly formManager: FormManagerService,
    protected readonly translate: TranslateService,
    protected readonly snackBarService: MatSnackBar,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly spinner: NgxSpinnerService,
    protected readonly cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public readonly data: CardDialogData,
  ) {
    super(
      snackBarService,
      translate,
      route,
      formManager,
      spinner,
      cd,
      cardOA.CardOAMeta,
      () => of(data.cardOa),
    );

    this.onFormInit$.pipe(
      filter((form): form is UntypedFormGroup => !!form),
      takeUntil(this.onDestroy$),
    ).subscribe((form) => {
      form.controls.codiceUnico.setAsyncValidators([checkUniqueCodeDuplicate(this.cardsApi.indexOA.bind(this.cardsApi), 0)]);
      form.controls.codiceUnico.updateValueAndValidity();
    });
  }

  addConcrete() {
    return EMPTY;
  }

  removeConcrete() {
    return EMPTY;
  }

  editConcrete() {
    return EMPTY;
  }

  resetFormConcrete() {
    return this.entityForm.reset();
  }

  async completeHandler() {
    if (this.entityForm.valid) {
      // Merge form value with benePadre from initial data to ensure it's included in the POST request
      const cardData = {
        ...this.entityForm.value,
        benePadre: this.data.cardOa.benePadre
      };
      
      const childCard = await firstValueFrom(this.cardsApi.postOA(cardData).pipe(first()));

      const confirmResult = await this.swalService.showConfirm({
        text: this.translate.instant('Vuoi andare alla pagina di dettaglio della scheda appena creata?'),
        title: this.translate.instant('Creazione avvenuta con successo'),
      });

      if (confirmResult) {
        this.router.navigate(['/cards/oa/manager', childCard.id]);
        this.dialogRef.close();
      } else {
        this.dialogRef.close(this.entityForm.value);
      }
    } else {
      this.entityForm.markAllAsTouched();
    }
  }

}
